import { type Dispatch, type SetStateAction, createContext } from 'react';
import type { NestleFormData, NestleFormErrors } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.types';

type NestleFormWrapperContextParams = {
    formData: NestleFormData;
    setFormData: Dispatch<SetStateAction<NestleFormData>>;
    formErrors: NestleFormErrors;
    setFormErrors: Dispatch<SetStateAction<NestleFormErrors>>;
};

export const NestleFormWrapperContext = createContext({} as NestleFormWrapperContextParams);
